<template>
    <div class="member-import-operate-detail">
        <bread-crumb :list="[{
            text: '会员管理',
            url: '/main/member/nav/memberList'
        }, {
            text: '会员导入',
            url: $route.params.from || '/main/member/memberImport'
        }, {
            text: '操作详情'
        }]"/>
        <div v-loading="isLoading" class="member-import-operate-detail__info">
            <div class="member-import-operate-detail__info-item">
                <div class="fx-v-center">
                    <span class="des">操 作 人 ：</span>
                    <span>
                        <user-info :userInfo="get(record, 'creator.user') || {}" />
                    </span>
                </div>
                <div class="fx-v-center">
                    <span class="des">会员导入：</span>
                    <span>{{ record.members_imported }}位</span>
                </div>
            </div>
            <div class="member-import-operate-detail__info-item">
                <div class="fx-v-center">
                    <span class="des">操作时间：</span>
                    <span>{{ record.create_time }}</span>
                </div>
                <div class="fx-v-center">
                    <span class="des">导入方式：</span>
                    <span class="text-popper" style="width: 300px" v-textPopper>{{ record.ls_shop_id ? '老零售店铺导入' : '表格导入' }}<span v-if="record.ls_shop_name" class="color-999" style="display: inline">（{{ record.ls_shop_name }}）</span></span>
                </div>
            </div>
        </div>
        <el-table v-loading="isLoading"
            ref="elTable"
            :data="tableData"
            :height="'calc(100vh - 229px)'">
            <el-table-column
                type="index"
                label="#">
            </el-table-column>
            <el-table-column
                label="会员姓名"
                prop="member_name"
                min-width="240">
                <template v-slot="{ row }">
                    <user-info v-if="row.user.id != null" :userInfo="row.user" />
                    <span class="text-popper" v-textPopper v-else>{{ row.realname }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="手机号"
                prop="phone"
                align="center"
                min-width="110">
            </el-table-column>
            <el-table-column
                label="生日"
                prop="birthday"
                align="center"
                min-width="110">
            </el-table-column>
            <el-table-column
                label="余额 (元)"
                prop="balance"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                label="积分"
                prop="point"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                label="卡号"
                prop="card_code"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column width="20" />
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && tableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import $fetch from '../../../api'
import { openMessage, useScrollLoad } from '../../../utils/system'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'

interface IImportRecordDetailParams {
    page: number
    limit: number
    record_id: number
}

export default createComponent({
    setup: (props, ctx) => {
        const isLoading = ref(false)
        const record = ref<{ [prop: string]: any }>({})
        const tableData = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const recordId = +ctx.root.$route.query.recordId

        onBeforeMount(() => {
            isLoading.value = true
            getImportRecordDetail()
                .then(() => isLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getImportRecordDetail
            })
        })

        function handleRecordData(memberList) {
            for (let i = 0; i < memberList.length; i++) {
                let temp = memberList[i]
                memberList[i].phone = memberList[i].phone || '-'
                memberList[i].birthday = memberList[i].birthday || '-'
                memberList[i].card_code = memberList[i].card_code || '-'
                if (memberList[i].user && !memberList[i].user.avatar) {  // 默认头像处理
                    memberList[i].user.avatar = '../../../assets/images/default_avatar.svg'
                }
            }
            return memberList
        }

        async function getImportRecordDetail(page = oPage.value, limit = 20, record_id: number = recordId) {
            try {
                if (!record_id) {
                    return openMessage('error', '无效recordId')
                }
                const params: IImportRecordDetailParams = {
                    page,
                    limit,
                    record_id
                }
                const result = await $fetch.post({
                    url: '/membership/migration/getlsmembersimported',
                    params
                })
                console.log('导入详情', clone(result))
                if (page === 1) {
                    record.value = result.record
                    tableData.value = handleRecordData(result.members)
                    initScrollLoad(result)
                } else {
                    tableData.value = tableData.value.concat(handleRecordData(result.members))
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取导入详情失败')
            }
        }

        return {
            isLoading,
            isScrollLoading,
            isHasMore,
            record,
            tableData,
            get
        }
    },
    components: {
        BreadCrumb
    }
})
</script>

<style lang="scss" scoped>
.member-import-operate-detail {
    font-size: 14px;
    color: #333;

    &__info {
        padding: 12px;
        background-color: #F9F9F9;

        &-item {
            display: flex;
            align-items: center;

            > div {
                flex: none;

                &:first-child {
                    .des + span {
                        width: 160px;
                    }
                }

                &:not(:first-child) {
                    margin-left: 66px;
                }

                > .des {
                    width: 70px;
                }
            }

            span {
                display: inline-block;
                height: 20px;
                line-height: 20px;
            }

            &:not(:first-child) {
                margin-top: 12px;
            }
        }
    }
}

::v-deep .el-table {
    margin-top: 20px !important;
}
</style>
